import bindHtmlModule from "./bindHtml/bindHtml.module";
import hasPermissionModule from "./hasPermission/hasPermission.module";
import intlTelInputModule from "./intlTelInput/intlTelInput.module";
import validEmail from "./validEmail/validEmail.module";
import focusInput from "./focusInput/focusInput.module";

const directivesModule = angular.module("app.directives", [
  bindHtmlModule.name,
  hasPermissionModule.name,
  intlTelInputModule.name,
  validEmail.name,
  focusInput.name,
]);

export default directivesModule;



// WEBPACK FOOTER //
// ./src/directives/index.js